export const protocolParams = Object.freeze({
  linearFee: {
    minFeeA: '44',
    minFeeB: '155381',
  },
  coinsPerUtxoWord: '34482',
  poolDeposit: '500000000',
  keyDeposit: '2000000',
  maxValueSize: 5000,
  maxTxSize: 16384,
})
